import { AxiosError } from 'axios';
import { GET_ADDRESS_DETAILS_URL } from '../../constants/apiUrls';
import { GET_ADDRESS_DETAILS_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { GenericErrorResponse } from '../typings';
import { useCustomQuery } from '../utils/useCustomQuery';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AddressDetails {
  SEARCHVAL: string;
  BLK_NO: number;
  ROAD_NAME: string;
  BUILDING: string;
  ADDRESS: string;
  POSTAL: number;
}

export interface AddressDetailsResponse {
  found: number;
  totalNumPages: number;
  pageNum: number;
  results: AddressDetails[];
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  postcode: string;
  enabled?: boolean;
  onSuccess?: (data: AddressDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAddressDetails = ({ postcode, enabled, onSuccess, onError }: Input) => {
  const getAddressDetails = async () => {
    const res = await axiosClient.get<AddressDetailsResponse>(GET_ADDRESS_DETAILS_URL(postcode), {
      withCredentials: false,
      // Might have to register for token if API fails with CORS once param deprecated
      // See https://www.onemap.gov.sg/apidocs/docs/verifyingsearchapitoken
    });
    return res.data;
  };

  return useCustomQuery([GET_ADDRESS_DETAILS_KEY, postcode], getAddressDetails, {
    onSuccess,
    onError,
    cacheTime: 0,
    enabled,
  });
};
